/** Whether a list page (/projects, /library) shows its first-visit layout
 *  ("Gerar meu primeiro corte", centered, no history).
 *
 *  Only when we know the account has nothing: from the server total once it
 *  arrived, else from the loaded list. While neither has loaded the answer is
 *  no, so a returning user sees the normal layout with skeletons instead of
 *  the first-visit screen for the seconds the list takes to load. */
export function resolveFirstVisit({
  serverTotal,
  loadedCount,
}: {
  serverTotal?: number | null;
  /** Rows loaded, or null while the list query has not returned. */
  loadedCount: number | null;
}): boolean {
  const knownTotal = typeof serverTotal === 'number' ? serverTotal : loadedCount;
  return knownTotal === 0;
}
